import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './actions'

Vue.use(Vuex)
const state = {
  //user是个对象,存放对象的信息 userTypeEnum:用户类型 CertificateStatusEnum:认证状态
  user: {
    userName: null,
    userId: null,
    userToken: null,
    userTypeEnum: null,
    certificateStatus: null,
    userPhone: null,
    type: -1
  },//type等于-1代表着没有登陆过
  enterForStartTime: '2021/03/15',//报名开始时间   需要这样的 2021/04/15格式  用于判断是否报名开始
  enterForEndTime: '2021/05/15',//报名结束时间  需要这样的 2021/04/15格式  用于判断是否报名结束
  enterForPageHint: '*截止报名:2021年4月15日', //报名页面展示的提示信息
  enterForPageCheck: '审核时间: 2021年5月20日-2021年5月30日', //报名页面的审核展示的提示信息
  enterForPageSuccess: '提交作品第一阶段将于2021年6月30日开始,更多消息请持续关注大赛!',//报名页面报名成功提示的信息


  register_enter_oneContribute_startTime: null, //注册、报名、上传摘要开始时间
  register_enter_oneContribute_endTime: null, //注册、报名、上传摘要截止时间
  oneContributeCheck_startTime: null,//第一阶段投稿审核开始时间
  oneContributeCheck_endTime: null,//第一阶段投稿审核结束时间
  twoContribute_startTime: null,//第二阶段投稿开始时间
  twoContribute_endTime: null,//第二阶段投稿结束时间
  twoContributeCheck_startTime: null,//第二阶段投稿审核开始时间
  twoContributeCheck_endTime: null,//第二阶段投稿审核结束时间
  threeContribute_startTime: null,//第三阶段投稿开始时间
  threeContribute_endTime: null,//第三阶段投稿结束时间
  reply_startTime: null,//答辩开始时间
  reply_endTime: null,//答辩结束时间

  curRound: 0,//投稿论文轮数
  certificate: 0,//报名是否开启
  round1Submit: 0,//投稿第一阶段是否开启
  round2Submit: 0,//投稿第二阶段是否开启
  round3Submit: 0,//投稿第三阶段是否开启
  qqState:null,
  newsNotice1:null,

  newsNotice: [],//通知公告的信息


}

export default new Vuex.Store({
  state,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js